export const AUTH       = 'AUTH';
export const SERVICE    = 'SERVICE';
export const LOGOUT     = 'LOGOUT';
export const COMPANY    = 'COMPANY';